import { render, staticRenderFns } from "./CedentInformation.vue?vue&type=template&id=061386e0&scoped=true&"
import script from "./CedentInformation.vue?vue&type=script&lang=js&"
export * from "./CedentInformation.vue?vue&type=script&lang=js&"
import style0 from "./CedentInformation.vue?vue&type=style&index=0&id=061386e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061386e0",
  null
  
)

export default component.exports